import React from "react";
import Breadcrumb from "@/components/Breadcrumb";
import SEO from "@/components/SEO";

export default function StaticPage({ title, description, content }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SEO title={`${title} — ImageKitHub`} description={description} />
      <Breadcrumb items={[{ label: title }]} />
      <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">{title}</h1>
      <div className="mt-8 text-slate-600 dark:text-slate-400 leading-relaxed space-y-4 whitespace-pre-line">{content}</div>
    </div>
  );
}
